$(function() {
	if($('.blog-tags a').hasClass("tagged-active")){
		var offsetLeft = $('.blog-tags .tagged-active').position().left;

		$('.blog-tags').animate({
		  scrollLeft: offsetLeft
		}, 0, 'swing');
	}
	$('.blog-tags').scroll(function () {
	  const el = $(this).scrollLeft();
	  
	  var boxWidth = this.offsetWidth;
	  var range = this.scrollWidth - this.offsetWidth;
	  
	  if (el == range || el > range) {
		$(".scroller-arrow").css({
		"display": "none",
		"right": - el
		});
	  }
	  else{
		$(".scroller-arrow").css({
		"display": "block",
		"right": - el
		});
	  }

	});
})